// frontend/src/lib/apiBase.js
// -----------------------------------------------------------------------
// Single runtime source of the backend API base URL -- Fase 1 of the
// Vynko launch plan. Replaces the ~10 duplicated
// `const API_BASE = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001"`
// declarations scattered across App.js and every NFC page.
//
// Why this needs to exist at all: REACT_APP_BACKEND_URL is baked into the
// build at build time (Create React App inlines process.env.REACT_APP_*
// at compile time), but this app now serves TWO brands from one build (see
// ops/Caddyfile's comment: one build, branding resolved in runtime). A
// build-time env var can only ever point at one API host, so on
// getvynko.com it would silently call api.revosdirector.com -- wrong
// origin, visible in every devtools network panel and in the CORS
// preflight, and a real trust problem on a payment page.
//
// Public API:
//   getApiBase() -> string
//     Computed from window.location.hostname each call (cheap, no need to
//     cache -- the hostname of a loaded page never changes mid-session).
//     Falls back to REACT_APP_BACKEND_URL (or localhost:8001) whenever
//     window isn't available (Jest/SSR) or the host isn't a recognized
//     Vynko host -- unknown/lookalike hosts get the SAME default as
//     today's behavior, never a guess.
//   API_BASE
//     Convenience constant computed once at module load, for call sites
//     migrating from the old `const API_BASE = ...` pattern with a pure
//     find-and-replace of the import. Prefer getApiBase() in anything
//     that might ever run before window exists.
// -----------------------------------------------------------------------

import { isVynkoHost } from "../nfc/vynkoBrand";

const DEFAULT_API_BASE = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
const VYNKO_API_BASE = process.env.REACT_APP_VYNKO_BACKEND_URL || "https://api.getvynko.com";

export function getApiBase() {
  if (typeof window === "undefined" || !window.location) {
    return DEFAULT_API_BASE;
  }
  return isVynkoHost(window.location.hostname) ? VYNKO_API_BASE : DEFAULT_API_BASE;
}

export const API_BASE = getApiBase();
